import * as React from 'react';
import * as intl from 'react-intl-universal';
import { PresentationError } from 'constants/ErrorTypes';
import Extension from 'containers/ChromeExtension';
import * as classes from './TogglePresenting.scss';

export interface Props {
  canPresent: boolean;
  isExtensionInstallVisible: boolean;
  isPresenting: boolean;
  presentationError: PresentationError;
  roomName: string;
  showPresentationSelector: any;
  stopPresenting: any;
}

const getPresentationError = (errorType: PresentationError) => {
  switch (errorType) {
    case PresentationError.ConnectionLost:
      return intl.get('presentation_error_connection_lost');
    case PresentationError.ConnectionLostTryAgain:
      return intl.get('presentation_error_connection_lost_try_again');
    default:
      return '';
  }
};

const getButtonLabel = (isPresenting: boolean) => {
  return isPresenting ? intl.get('button_stop_sharing_screen') : intl.get('button_share_screen');
};

class TogglePresenting extends React.PureComponent<Props> {
  onTogglePresentation = () => {
    if (this.props.isPresenting) {
      this.props.stopPresenting();
    }
    else {
      this.props.showPresentationSelector();
    }
  }

  render() {
    const presentationError = getPresentationError(this.props.presentationError);
    return (
      <div className={classes.content}>
        <h2 className={classes.title}>{this.props.roomName}</h2>
        <button
          disabled={!this.props.canPresent && !this.props.isPresenting}
          onClick={this.onTogglePresentation}
          type="button"
        >
          <div className={classes.buttonIcon}>
            <span className="icon icon-share-screen" />
          </div>
          <div className={classes.buttonLabel}>{getButtonLabel(this.props.isPresenting)}</div>
        </button>
        <p className={classes.errorMessage}>
          {presentationError && <span className={`icon icon-exclamation ${classes.icon}`} />}
          {presentationError}
        </p>
        {this.props.isExtensionInstallVisible && <Extension />}
      </div>
    );
  }
}

export default TogglePresenting;



// WEBPACK FOOTER //
// ./src/components/TogglePresenting.tsx